export const apmConfig = {
    serviceName: process.env.CT_PUBLIC_SERVICE_NAME,
    serverUrl: process.env.CT_PUBLIC_ELASTIC_APM_SERVER_BASE_URL,
    environment: process.env.CT_PUBLIC_CT_ENV,
    breakdownMetrics: true,
};